import { Phone, MessageSquare } from "lucide-react";
import { BUSINESS_PHONE } from "@/lib/constants";

export default function StickyMobileCTA() {
    return (
        <div
            className="fixed bottom-0 inset-x-0 z-40 md:hidden"
            data-testid="sticky-mobile-cta"
        >
            <div className="mx-3 mb-3 rounded-2xl glass p-2 flex gap-2 shadow-2xl">
                <a
                    href={`tel:${BUSINESS_PHONE}`}
                    data-testid="mobile-cta-call"
                    className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-white/5 text-white text-sm font-semibold border border-white/10"
                >
                    <Phone className="w-4 h-4" /> Call
                </a>
                <a
                    href={`sms:${BUSINESS_PHONE}?&body=Hi, I'd like help comparing electricity options.`}
                    data-testid="mobile-cta-text"
                    className="flex-1 inline-flex items-center justify-center gap-2 py-3 rounded-xl bg-emerald-500 text-emerald-950 text-sm font-bold"
                >
                    <MessageSquare className="w-4 h-4" /> Text me
                </a>
            </div>
        </div>
    );
}
